import { render } from "./SimpleDateV2.vue?vue&type=template&id=0fc434e0&scoped=true&ts=true"
import script from "./SimpleDateV2.vue?vue&type=script&lang=ts"
export * from "./SimpleDateV2.vue?vue&type=script&lang=ts"

import "./SimpleDateV2.vue?vue&type=style&index=0&id=0fc434e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc434e0"]])

export default __exports__